import React, { InputHTMLAttributes, useEffect, useRef } from 'react';
import { useField } from '@unform/core';
import { Container, ErroInput } from '../styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement>{
    name: string;
}

const Input: React.FC<InputProps> = ({name, ...rest}) => {
    const inputRef = useRef(null);
    const { fieldName, defaultValue, error, registerField } = useField(name)

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: inputRef.current,
            path: 'value',
        })
    }, [fieldName, registerField])

    return (
    <Container>
        <input defaultValue={defaultValue} ref={inputRef} {...rest} />
        {error && <ErroInput><span className="material-icons" title={error}>warning</span></ErroInput> }
    </Container>
    );
}

export default Input;